module.exports = __webpack_public_path__ + "static/media/Resume (Thomas McDonald).b82f8c72.pdf";